(function () {
  'use strict';

  function parseSections() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-juno-reviews-wall]')
    );
  }

  function formatDate(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (e) {
      return '';
    }
  }

  function starsHtml(rating) {
    var n = Math.round(parseFloat(rating) || 0);
    var out = '';
    for (var i = 1; i <= 5; i += 1) {
      out += '<span class="juno-reviews-wall__star' + (i <= n ? ' is-filled' : '') + '" aria-hidden="true">★</span>';
    }
    return out;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchAllReviews(shopDomain, apiToken) {
    var perPage = 50;
    var page = 1;
    var all = [];

    function nextPage() {
      var url = 'https://judge.me/api/v1/reviews?shop_domain=' +
        encodeURIComponent(shopDomain) +
        '&api_token=' + encodeURIComponent(apiToken) +
        '&page=' + page +
        '&per_page=' + perPage;

      return fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Judge.me API error');
          return res.json();
        })
        .then(function (data) {
          var batch = (data && data.reviews) ? data.reviews : [];
          batch.forEach(function (r) {
            if (!r.hidden) all.push(r);
          });
          if (batch.length >= perPage) {
            page += 1;
            return nextPage();
          }
          return all;
        });
    }

    return nextPage();
  }

  function renderReviewCard(review) {
    var name = (review.reviewer && review.reviewer.name) || 'Verified customer';
    var body = review.body || '';
    var title = review.title || '';
    var date = formatDate(review.created_at);
    var rating = review.rating || 5;
    var verified = review.verified && review.verified !== 'nothing';
    var picture = review.pictures && review.pictures[0] && review.pictures[0].urls
      ? (review.pictures[0].urls.compact || review.pictures[0].urls.small)
      : '';

    var html = '<article class="juno-reviews-wall__card">';
    html += '<div class="juno-reviews-wall__card-header">';
    html += '<div class="juno-reviews-wall__card-stars" role="img" aria-label="' + rating + ' out of 5 stars">' + starsHtml(rating) + '</div>';
    if (date) html += '<time class="juno-reviews-wall__card-date" datetime="' + escapeHtml(review.created_at) + '">' + escapeHtml(date) + '</time>';
    html += '</div>';
    html += '<div class="juno-reviews-wall__card-author">' + escapeHtml(name);
    if (verified) html += ' <span class="juno-reviews-wall__verified">Verified</span>';
    html += '</div>';
    if (title) html += '<h3 class="juno-reviews-wall__card-title">' + escapeHtml(title) + '</h3>';
    if (body) html += '<div class="juno-reviews-wall__card-body"><p>' + escapeHtml(body) + '</p></div>';
    if (picture) {
      html += '<img class="juno-reviews-wall__card-photo" src="' + escapeHtml(picture) + '" alt="" loading="lazy" width="160" height="160">';
    }
    html += '</article>';
    return html;
  }

  function renderApiGrid(sectionEl, reviews) {
    var grid = sectionEl.querySelector('[data-juno-reviews-wall-grid]');
    var widget = sectionEl.querySelector('[data-juno-reviews-wall-widget]');
    var loading = sectionEl.querySelector('[data-juno-reviews-wall-loading]');
    if (!grid) return;

    reviews.sort(function (a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    });

    grid.innerHTML = reviews.map(renderReviewCard).join('');
    grid.hidden = false;
    if (widget) widget.hidden = true;
    sectionEl.classList.add('is-loaded');
    if (loading) loading.setAttribute('hidden', '');
  }

  function showError(sectionEl, message) {
    var grid = sectionEl.querySelector('[data-juno-reviews-wall-grid]');
    var loading = sectionEl.querySelector('[data-juno-reviews-wall-loading]');
    if (grid) {
      grid.hidden = false;
      grid.innerHTML = '<p class="juno-reviews-wall__error">' + escapeHtml(message) + '</p>';
    }
    sectionEl.classList.add('is-loaded');
    if (loading) loading.setAttribute('hidden', '');
  }

  function layoutSummaryCard(sectionEl) {
    var summary = sectionEl.querySelector('.jdgm-rev-widg__summary, .jdgm-all-reviews__summary');
    if (!summary || summary.dataset.junoLayout === 'true') return;

    var inner = summary.querySelector('.jdgm-rev-widg__summary-inner');
    var histogram = summary.querySelector('.jdgm-histogram');
    var writeBtn = summary.querySelector(
      '.jdgm-write-rev-link, .jdgm-rev-widg__write-review-btn, .jdgm-btn.jdgm-write-rev-link'
    );

    if (!inner && !histogram) return;

    summary.querySelectorAll('a').forEach(function (link) {
      if (/see all/i.test(link.textContent || '')) {
        link.remove();
      }
    });

    var layout = document.createElement('div');
    layout.className = 'juno-reviews-wall__summary-layout';

    var left = document.createElement('div');
    left.className = 'juno-reviews-wall__summary-left';

    var right = document.createElement('div');
    right.className = 'juno-reviews-wall__summary-right';

    if (inner) left.appendChild(inner);
    if (writeBtn) left.appendChild(writeBtn);
    if (histogram) right.appendChild(histogram);

    layout.appendChild(left);
    if (histogram) layout.appendChild(right);

    while (summary.firstChild) summary.removeChild(summary.firstChild);
    summary.appendChild(layout);
    summary.dataset.junoLayout = 'true';
  }

  function polishWidgetUi(sectionEl) {
    layoutSummaryCard(sectionEl);

    var writeLinks = sectionEl.querySelectorAll(
      '.jdgm-write-rev-link, .jdgm-rev-widg__write-review-btn, .jdgm-btn.jdgm-write-rev-link'
    );
    writeLinks.forEach(function (el) {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('background-color', '#1b4332', 'important');
      el.style.setProperty('border', 'none', 'important');
    });
  }

  function waitForWidget(sectionEl) {
    var loading = sectionEl.querySelector('[data-juno-reviews-wall-loading]');
    var attempts = 0;

    function check() {
      var hasSummary = sectionEl.querySelector('.jdgm-rev-widg__summary, .jdgm-histogram');
      var hasReviews = sectionEl.querySelector('.jdgm-rev');
      if (hasSummary || hasReviews) {
        polishWidgetUi(sectionEl);
      }
      if (hasReviews) {
        sectionEl.classList.add('is-loaded');
        if (loading) loading.setAttribute('hidden', '');
        return true;
      }
      return false;
    }

    if (check()) return;

    var interval = setInterval(function () {
      attempts += 1;
      if (check() || attempts >= 30) {
        clearInterval(interval);
        if (!sectionEl.classList.contains('is-loaded') && loading) {
          loading.innerHTML = '<span>Add your Judge.me API token in the Review Wall section settings, or enable the Review Widget in Judge.me.</span>';
        }
      }
    }, 500);

    ['judgeme:loaded', 'judgeme:reviews-loaded', 'judgeme:ready'].forEach(function (name) {
      window.addEventListener(name, function () {
        polishWidgetUi(sectionEl);
        check();
      });
    });
  }

  function initSection(sectionEl) {
    var shopDomain = sectionEl.getAttribute('data-shop-domain');
    var apiToken = sectionEl.getAttribute('data-api-token');
    var useApi = sectionEl.getAttribute('data-use-api') === 'true' && shopDomain && apiToken;

    if (useApi) {
      fetchAllReviews(shopDomain, apiToken)
        .then(function (reviews) {
          if (!reviews.length) {
            showError(sectionEl, 'No published reviews found yet.');
            return;
          }
          renderApiGrid(sectionEl, reviews);
        })
        .catch(function () {
          waitForWidget(sectionEl);
        });
      return;
    }

    waitForWidget(sectionEl);
  }

  function run() {
    parseSections().forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
